module.exports = __webpack_public_path__ + "static/media/join-in-img4-1.e409b8a5.png";